/**
 *  @fileOverview Data Record Modal module, initalises  modal instances based upon data records created in ssjs, uses https://micromodal.now.sh/
 *
 *  @author       Aaron Chapman / Chris Hill
 *
 */

function DataRecordModalModule (Micromodal) {
  /**
   * @description Initialises modal instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    let modal = document.querySelector('#modalURLLoader')

    if (modal != null) { // Make sure modal element exists
      Micromodal.show('modalURLLoader', {
        onClose: modal => modal.parentNode.removeChild(modal)
      })

      let closebtn = document.querySelector('.modal__close')

      closebtn.addEventListener('click', function (e) {
        e.preventDefault()

        Micromodal.close('modalURLLoader')
        closebtn.removeEventListener('click', function (e) {})
      })
    }
  }
}

module.exports = DataRecordModalModule
